export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-be_dt@2x.43748f7b.png";